var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-header'),_c('z-stepper'),(_vm.isRouteForHelp)?_c('z-sidebar-help',{staticStyle:{"z-index":"4000"}}):_vm._e(),_c('div',{staticClass:"content"},[_c('div',{staticClass:"pt-5"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }